export const CARDS_PROP = {
  IMAGE: "image",
  IMAGE_SECOND: "imageSecond",
  TEXT_ALIGN: "textAlign",
  LAYOUT: "layout",
  BORDER_RADIUS: "borderRadius",
  NEW_TAB: "newTab",
  LINK: "link",
  TITLE: "title",
  TEXT: "text",
  LABEL: "label",
  ARROW: "arrow",
  OVERLAY: "overlay",
  DESIGN: "design",
  COLUMNS: "columns",
  ICON: "icon",
  HAS_TABS: "hasTabs",
  TAB_ID: "tabId",
  TYPE: "type",
  COLORS: "colors",
  LINK_TEXT: "linkText",
  NUMBER: "number",
};

export const CARD_DESIGN = {
  IMAGE_ONE: "image-one",
  IMAGE_TWO: "image-two",
  IMAGE_THREE: "image-three",
  IMAGE_FOUR: "image-four",
  IMAGE_FIVE: "image-five",
  IMAGE_SIX: "image-six",
  IMAGE_SEVEN: "image-seven",
  IMAGE_EIGHT: "image-eight",
  EMOJI_ONE: "emoji-one",
  EMOJI_TWO: "emoji-two",
  ATLASSIAN_ONE: "atlassian-one",
  ATLASSIAN_TWO: "atlassian-two",
  STEPS_ONE: "steps-one",
  STEPS_TWO: "steps-two",
  NUMBER_ONE: "number-one",
  NUMBER_TWO: "number-two",
};

export const DESIGNS_OPTIONS = {
  ICON: [CARD_DESIGN.NUMBER_ONE, CARD_DESIGN.NUMBER_TWO],
  SUBTEXT: [
    CARD_DESIGN.IMAGE_ONE,
    CARD_DESIGN.IMAGE_TWO,
    CARD_DESIGN.IMAGE_THREE,
    CARD_DESIGN.IMAGE_FOUR,
    CARD_DESIGN.IMAGE_FIVE,
    CARD_DESIGN.IMAGE_EIGHT,
    CARD_DESIGN.EMOJI_ONE,
    CARD_DESIGN.EMOJI_TWO,
    CARD_DESIGN.ATLASSIAN_ONE,
    CARD_DESIGN.ATLASSIAN_TWO,
    CARD_DESIGN.STEPS_ONE,
    CARD_DESIGN.STEPS_TWO,
    CARD_DESIGN.NUMBER_ONE,
    CARD_DESIGN.NUMBER_TWO,
  ],
  LINK_TEXT: [
    CARD_DESIGN.IMAGE_SIX,
    CARD_DESIGN.IMAGE_SEVEN,
    CARD_DESIGN.STEPS_ONE,
  ],
  LABEL: [
    CARD_DESIGN.IMAGE_ONE,
    CARD_DESIGN.IMAGE_TWO,
    CARD_DESIGN.IMAGE_THREE,
    CARD_DESIGN.IMAGE_FOUR,
    CARD_DESIGN.IMAGE_SEVEN,
    CARD_DESIGN.IMAGE_EIGHT,
    CARD_DESIGN.EMOJI_ONE,
    CARD_DESIGN.EMOJI_TWO,
    CARD_DESIGN.ATLASSIAN_ONE,
    CARD_DESIGN.ATLASSIAN_TWO,
  ],
  ARROW: [
    CARD_DESIGN.IMAGE_ONE,
    CARD_DESIGN.IMAGE_TWO,
    CARD_DESIGN.IMAGE_THREE,
    CARD_DESIGN.IMAGE_FOUR,
    CARD_DESIGN.IMAGE_SIX,
    CARD_DESIGN.IMAGE_SEVEN,
    CARD_DESIGN.EMOJI_ONE,
    CARD_DESIGN.EMOJI_TWO,
    CARD_DESIGN.ATLASSIAN_TWO,
    CARD_DESIGN.STEPS_ONE,
  ],
  LABEL_COLOR: [CARD_DESIGN.IMAGE_SIX],
};

export const CARD_TYPE = {
  STEPS: "steps",
  NUMBER: "number",
  EMOJI: "emoji",
};

export const LIBRARY_SERVICE_ACTION = {
  create: "addCard",
  edit: "editCard",
};

export const EMOJI_TEMPLATE_TABS = {
  [CARD_DESIGN.EMOJI_ONE]: ["Emojis", "Logos"],
  [CARD_DESIGN.EMOJI_TWO]: ["Icons", "Emojis", "Logos"],
};

export const CARD_DESIGN_COLUMNS = {
  [CARD_DESIGN.IMAGE_ONE]: [1, 2, 3, 4],
  [CARD_DESIGN.IMAGE_TWO]: [1, 2, 3, 4],
  [CARD_DESIGN.IMAGE_THREE]: [1, 2, 3, 4],
  [CARD_DESIGN.IMAGE_FOUR]: [1, 2, 3, 4],
  [CARD_DESIGN.IMAGE_FIVE]: [1, 2, 3, 4],
  [CARD_DESIGN.IMAGE_SIX]: [1, 2, 3, 4],
  [CARD_DESIGN.IMAGE_SEVEN]: [1, 2, 3, 4],
  [CARD_DESIGN.IMAGE_EIGHT]: [2, 3, 4],
  [CARD_DESIGN.EMOJI_ONE]: [1, 2, 3, 4],
  [CARD_DESIGN.ATLASSIAN_ONE]: [2, 3, 4],
  [CARD_DESIGN.ATLASSIAN_TWO]: [1, 2, 3, 4],
  [CARD_DESIGN.NUMBER_ONE]: [1, 2, 3, 4],
  [CARD_DESIGN.NUMBER_TWO]: [1, 2, 3, 4],
  DEFAULT: [1, 2, 3, 4, 5],
};
